import $ from 'jquery'
export const UA_TABLET = {
  init: function () {
    const targetUa = navigator.userAgent.toLowerCase()
    const isTablet = this.isIpad(targetUa) || this.isAndroidTablet(targetUa)

    if (isTablet) {
      $("meta[name='viewport']").attr('content', 'width=1280px')
    }
  },
  isIpad: function (ua) {
    return ua.includes('ipad')
  },
  isAndroidTablet: function (ua) {
    return ua.includes('android') && !ua.includes('mobile')
  },
}
